import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
class AutomatedOverriddingRiskModal extends Component {
    constructor() {
        super()
        this.state = {
            overriddingRiskFactorCreatedFlag: false,
            modalType: '',
            overriddingRiskFactorErrorFlag: false,
            overiddingRiskFactorErrorMessage: ''
        }
    }
    componentDidUpdate(prevProps) {
        const { createAutomatedOverriddingRiskFactorSuccess, createAutomatedOverriddingRiskFactorFailure, editAutomatedOverriddingRiskFactorSuccess, editAutomatedOverriddingRiskFactorFailure } = this.props
        if (editAutomatedOverriddingRiskFactorSuccess !== prevProps.editAutomatedOverriddingRiskFactorSuccess) {
            if (editAutomatedOverriddingRiskFactorSuccess.status === 200) {
                this.setState({
                    modalType: 'Edited',
                    overriddingRiskFactorCreatedFlag: true
                })
            }
        }
        if (createAutomatedOverriddingRiskFactorSuccess !== prevProps.createAutomatedOverriddingRiskFactorSuccess) {
            if (createAutomatedOverriddingRiskFactorSuccess.status === 200) {
                this.setState({
                    modalType: 'Created',
                    overriddingRiskFactorCreatedFlag: true
                })
            }
        }
        if (createAutomatedOverriddingRiskFactorFailure !== prevProps.createAutomatedOverriddingRiskFactorFailure || editAutomatedOverriddingRiskFactorFailure !== prevProps.editAutomatedOverriddingRiskFactorFailure) {
            if (createAutomatedOverriddingRiskFactorFailure) {
                this.setState({
                    overriddingRiskFactorErrorFlag: !this.state.overriddingRiskFactorErrorFlag,
                    uploadModalErrorMessage: (this.props.createAutomatedOverriddingRiskFactorFailure.response && this.props.createAutomatedOverriddingRiskFactorFailure.response.data) ? this.props.createAutomatedOverriddingRiskFactorFailure.response.data.message : "Something went wrong! Please try again."
                })
            } else if (editAutomatedOverriddingRiskFactorFailure) {
                this.setState({
                    overriddingRiskFactorErrorFlag: !this.state.overriddingRiskFactorErrorFlag,
                    uploadModalErrorMessage: (this.props.editAutomatedOverriddingRiskFactorFailure.response && this.props.editAutomatedOverriddingRiskFactorFailure.response.data) ? this.props.editAutomatedOverriddingRiskFactorFailure.response.data.message : "Something went wrong! Please try again."
                })
            }
        }
    }
    toggle = () => {
        this.setState({ overriddingRiskFactorCreatedFlag: !this.state.overriddingRiskFactorCreatedFlag })
    }
    errorclose = () => {
        this.setState({ overriddingRiskFactorErrorFlag: !this.state.overriddingRiskFactorErrorFlag })
    }
    redirectView = () => {
        this.props.modalCallBack();
    }
    render() {
        return (
            <div>
                <Modal isOpen={this.state.overriddingRiskFactorCreatedFlag} toggle={this.toggle} className={this.props.className}>
                    <ModalHeader toggle={this.toggle}>Success</ModalHeader>
                    <ModalBody>
                        Automated Overridng Risk Factor Successfully {this.state.modalType}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.toggle}>Cancel</Button>
                        <Button color="info" onClick={this.redirectView}>View</Button>
                    </ModalFooter>
                </Modal>
                <Modal isOpen={this.state.overriddingRiskFactorErrorFlag} toggle={this.errorclose} className={this.props.className}>
                    <ModalHeader toggle={this.errorclose}>Error</ModalHeader>
                    <ModalBody>
                        {this.state.overiddingRiskFactorErrorMessage}
                    </ModalBody>
                    <ModalFooter>
                        <Button color="secondary" onClick={this.errorclose}>Cancel</Button>
                    </ModalFooter>
                </Modal>
            </div>
        )
    }
}
const mapStateToProps = (state, ownProps) => ({
    createAutomatedOverriddingRiskFactorSuccess: state.automatedOverriddingRiskFactor.createAutomatedOverriddingRiskFactorSuccess,
    createAutomatedOverriddingRiskFactorFailure: state.automatedOverriddingRiskFactor.createAutomatedOverriddingRiskFactorFailure,
    editAutomatedOverriddingRiskFactorSuccess: state.automatedOverriddingRiskFactor.editSuccess,
    editAutomatedOverriddingRiskFactorFailure: state.automatedOverriddingRiskFactor.editFailed
})

const mapDispatchToProps = (dispatch, ownProps) => ({
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AutomatedOverriddingRiskModal);